<style scoped>
    .slect_one {
        color: red;
    }

    .all_subs {
        padding: 0px !important;
        overflow-y: hidden !important;
    }

    .set_nav {
        height: 48px !important;
        margin-bottom: 25px !important;
    }

    .inner_nav_height {
        min-height: 29px !important;
    }

    .nav-item {
        padding: 0px;
    }

    .guest_user {
        margin-top: 45px;
        height: auto !important;
    }

    .humtog_s {
        margin-bottom: 27px;
    }
</style>
<template>
    <div>
        <el-row :gutter="24" class="hidemargininmob">
            <div class="h-content">
                <div class="home-wrapper" id="home">
                    <div v-if="isLoggedIn" class="nav has-shadow user-select set_nav">
                        <div class="container inner_nav_height">
                            <router-link :to="{name: 'HumTogSubmission', params: { pt: 'text'}, query: { type: 'location', name: 'India'} }"
                                         class="el-button wide-btn full-width submit-post-btn">Create a post</router-link>
                            <router-link :to="{name: 'HumTogSubmission', params: { pt: 'img'}, query: { type: 'location', name: 'India'} }"
                                         class="el-button headericons v-picture no-border"></router-link>
                            <router-link :to="{name: 'HumTogSubmission', params: { pt: 'link'}, query: { type: 'location', name: 'India' } }"
                                         class="el-button headericons v-link no-border"></router-link>
                        </div>
                    </div>
                    <div class="nav has-shadow set_nav"
                         :class="{'shade-item relative': showTour && activeTour.id === 'feed'}">
                        <tour v-if="showTour && activeTour.id == 'feed'"
                              :position="{ top: '7em', left: '39%' }"></tour>


                        <div class="container inner_nav_height">
                            <div class="nav-left">
                                <router-link
                                        :to="{ name: 'home' }"
                                        class="nav-item is-tab"
                                        :class="{ 'is-active': sort === 'all' }"
                                >All
                                </router-link>
                                <router-link
                                        :to="{ name: 'home', query: { sort: 'serious' } }"
                                        class="nav-item is-tab"
                                        :class="{ 'is-active': sort === 'serious' }"
                                >Serious
                                </router-link>
                                <router-link
                                        :to="{ name: 'home', query: { sort: 'relaxed' } }"
                                        class="nav-item is-tab"
                                        :class="{ 'is-active': sort === 'relaxed' }"
                                >Relaxed
                                </router-link>
                            </div>

                            <!--<el-tooltip content="Scroll to top" placement="bottom" transition="false" :open-delay="500">-->
                            <!--<img src="/imgs/Humtog.png" class="logo" alt="Humtog" @click="scrollToTop('submissions')">-->
                            <!--</el-tooltip>-->

                            <div class="flex-center">
                                <el-tooltip
                                        content="Refresh"
                                        placement="bottom"
                                        transition="false"
                                        :open-delay="500"
                                >
                                    <button class="feed-panel-button" @click="refresh">
                                        <i class="el-icon-refresh" :class="{'rotate': refreshing}"></i>
                                    </button>
                                </el-tooltip>

                                <el-tooltip v-if="isLoggedIn" content="Turn on to only show subscribed">
                                    <el-switch v-model="showUserChannels"></el-switch>
                                </el-tooltip>

                                <!--                <el-tooltip-->
                                <!--                        content="Customize Feed"-->
                                <!--                        placement="bottom"-->
                                <!--                        transition="false"-->
                                <!--                        :open-delay="500"-->
                                <!--                        v-if="isLoggedIn"-->
                                <!--                >-->
                                <!--                  <button-->
                                <!--                    class="feed-panel-button margin-right-half"-->
                                <!--                    @click="Store.modals.feedSettings.show = true"-->
                                <!--                  >-->
                                <!--                    <i class="el-icon-setting"></i>-->
                                <!--                  </button>-->
                                <!--                </el-tooltip>-->

                                <!--<el-button round type="primary" size="mini" @click="submit" v-if="isLoggedIn">-->
                                <!--Submit-->
                                <!--</el-button>-->
                            </div>
                        </div>
                    </div>

                    <section
                            id="submissions"
                            class="home-submissions all_subs"
                            :class="{'flex-center' : nothingFound}"
                            v-infinite-scroll="loadMore"
                            infinite-scroll-distance="200"
                            infinite-scroll-disabled="cantLoadMore"
                            @scroll.passive="scrolled"
                    >
                        <div v-for="(value, index) in uniqueList" v-bind:key="value.id">
                            <!-- SUGGEST CHANNEL FEATURE - Important for future
                                 <suggested-channel v-if="isLoggedIn && index == 5"></suggested-channel> -->

                            <submission :lightbox="true" :list="value"></submission>
                        </div>

                        <no-content
                                v-if="Store.page.home.nothingFound"
                                :text="'No submissions at this time. Try subscribing to more channels or adjusting your feed filters.'"
                        ></no-content>

                        <loading v-if="loading && page > 1"></loading>

                        <no-more-items :text="'No more items to load'"
                                       v-if="NoMoreItems && !nothingFound"></no-more-items>
                    </section>
                </div>
            </div>

            <div class="h-sidebar">
                <div class="sidebar-right comtt_c">
                    <!--           <el-card class="box-card humtog_s">
                                <p>
                                  <a href="#">Entire world view</a>
                                  <br />
                                  <a href="#">Your country - India</a>
                                  <br />
                                  <a href="#">All countries list</a>
                                </p>
                              </el-card> -->
                    <el-card class="box-card humtog_s">
                        <h2 class="community_chanel">What is Humtog?</h2>
                        <p>
                            Humtog is a collaboration platform to make it possible for people to work together in
                            achieving common goals like eradicating poverty or illiteracy. We can solve most problems in
                            this world if a few good people come together to fix them. This is a platform for such
                            people.
                            <br>
                            <br>As you can see, that is not an easy thing to do. So, we are currently an Indian news discussion platform until we get a large enough user-base to achieve our main goals. Join
                            Humtog and let's save the world bit by bit.
                        </p>
                        <!--  <div style="text-align: center">
                            <router-link class="item h_b" to="/">Learn More</router-link>
                        </div> -->
                    </el-card>
                    <el-card class="box-card humtog_s">
                        <h2 class="community_chanel">Alpha version!</h2>
                        <p>
                            You are one of the first few users of this site. This is currently in alpha version and
                            may contain lot of bugs. Some features like NewsWorthy is disabled temporarily because it
                            cannot work without reaching a certain level of users.
                            <br>
                            <br>If you have ever wanted to be among the first few users of any social media app, then
                            this is
                            your chance. Thanks for being part of this new adventure, hope you will join me on this long
                            journey.
                        </p>
                        <!--  <div style="text-align: center">
                            <router-link class="item h_b" to="/">Learn More</router-link>
                        </div> -->
                    </el-card>
                    <!--           <el-card class="box-card humtog_s">
                                <h2 class="community_chanel">Project NewsWorthy</h2>
                                <p>We are starting an initiative to filter out the cluter in the news and just show the most important news of the day in a gist. Join it to help us fight the fake news.</p>
                                <div style="text-align: center">
                                  <router-link class="item h_b" to="/signup">Learn More</router-link>
                                </div>
                              </el-card>
                              <el-card class="box-card humtog_s">
                                <div>
                                  <h2 class="community_chanel">Feed Filters</h2>
                                  <div class="f_f_m">
                                    <div class="f_f">
                                      <a
                                        href="javascript:void(0);"
                                        @click="feed('News')"
                                        class="nav-itemis-tab"
                                      >News Only ></a>
                                    </div>
                                    <div class="f_f">
                                      <a
                                        href="javascript:void(0);"
                                        @click="feed('article')"
                                        class="nav-itemis-tab"
                                      >Articles Only ></a>
                                    </div>
                                    <div class="f_f">
                                      <a
                                        href="javascript:void(0);"
                                        @click="feed('Question')"
                                        class="nav-itemis-tab"
                                      >Q&A Only ></a>
                                    </div>
                                    <div class="f_f">
                                      <a
                                        href="javascript:void(0);"
                                        @click="feed('img')"
                                        class="nav-itemis-tab"
                                      >Photos Only ></a>
                                    </div>
                                  </div>
                                </div>
                              </el-card> -->
                </div>
            </div>
        </el-row>
    </div>
</template>

<script>
    import Helpers from "../mixins/Helpers";
    import Submission from "../components/Submission.vue";
    import SuggestedChannel from "../components/SuggestedChannel.vue";
    import Loading from "../components/Loading.vue";
    import NoContent from "../components/NoContent.vue";
    import NoMoreItems from "../components/NoMoreItems.vue";
    import HomeSidebar from "../components/sidebars/HomeSidebar.vue";
    import Tour from "../components/Tour";

    export default {
        props: {
            pageName: {
                type: String,
                default: '',
            }
        },
        mixins: [Helpers],

        components: {
            Submission,
            Loading,
            SuggestedChannel,
            NoContent,
            NoMoreItems,
            Tour,
            HomeSidebar
        },

        data() {
            return {
                refreshing: false,
                showUserChannels: Store.settings.feed.submissionsFilter === 'subscribed'
            };
        },

        created() {
            this.setPageTitle("Humtog: " + Laravel.title, true);
            this.startTour();
            Store.settings.feed.submissionsFilter = 'all'
            this.$eventHub.$on("refresh-home", this.refresh);
        },

        beforeDestroy() {
            this.$eventHub.$off("refresh-home", this.refresh);
        },

        computed: {
            cantLoadMore() {
                return this.loading || this.NoMoreItems || this.nothingFound;
            },

            NoMoreItems() {
                return Store.page.home.NoMoreItems;
            },

            nothingFound() {
                return Store.page.home.nothingFound;
            },

            submissions() {
                return Store.page.home.submissions;
            },

            loading() {
                return Store.page.home.loading;
            },

            sort() {
                return this.$route.query.sort ? this.$route.query.sort : "all";
            },

            page() {
                return Store.page.home.page;
            },

            uniqueList() {
                return _.uniqBy(this.submissions, "id");
            }
        },

        methods: {
            loadMore() {
                console.log("load more");
                Store.page.home.getSubmissions(this.sort);
            },
            feed(type) {
                Store.settings.feed.submissionsType = type;

                this.refresh();
                //  Store.page.home.getSubmissions(to.query.sort)
            },

            refresh: _.debounce(
                function () {
                    this.refreshing = true;

                    Store.page.home.clear();

                    Store.page.home
                        .getSubmissions(this.sort, this.pageName)
                        .then(() => {
                            this.refreshing = false;
                        })
                        .catch(() => {
                            this.refreshing = false;
                        });
                },
                200,
                {leading: true, trailing: false}
            ),

            submit() {
                this.$eventHub.$emit("submit");
            },

            startTour() {
                if (this.$route.query.newbie == 1) {
                    Store.tour.show = true;
                }
            }
        },

        watch: {
            showUserChannels(val) {
                Store.settings.feed.submissionsFilter = val ? 'subscribed' : 'all'
            },

            'Store.settings.feed.submissionsFilter'() {
                this.$eventHub.$emit('refresh-home');
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/HomeContent.vue